// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index[data-v-059e4614] {\n  font-size: 2.5em;\n  font-style: oblique;\n  color: #d7d7d7;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  width: 500px;\n}", ""]);
// Exports
module.exports = exports;
